export default {
    name:"Tabs",

    data() {
        return {
            tab: null
        }
    },

    props: {
        tabNames: {
            type: Array,
            required: true,
            default() {return []}
        }
    }
}